<div id="modal-container">
  <table id="search-add-tbl">
    <tr style="height: fit-content">
      <th class="search">
        <app-comparative-ticker-search
          [isComp]="true"
          [isTickerTypeBg]="isTickerTypeBg"
          [selectedOption]="leftSectionTickerData"
          [suggestedTickers]="suggestedPeers && suggestedPeers['company_info']"
          [recentlyVisitedTickers]="
            (recentlyVisited && recentlyVisited['company_info']) ||
            (recentlyVisitedCompanies &&
              recentlyVisitedCompanies['company_info'])
          "
          [watchlistData]="watchlistData"
          [industryData]="industryData"
          [marketGeoData]="marketGeoData"
          [menuList]="menuList"
          [isCreateNewModalIndustryMenu]="isCreateNewModalIndustryMenu"
          (tickerToEmit)="addSearchedTicker($event)"
          (handleMenuApply)="handleMenuApply($event)"
          (handleTickerMenuChange)="handleMenuItemChange($event)"
        ></app-comparative-ticker-search>
      </th>
      <th>Selected Companies (up to {{ maxTickers }}):</th>
    </tr>
    <tr>
      <td class="add">
        <div
          *ngIf="leftSectionTickerData && leftSectionTickerData.watchername"
          class="content-heading"
        >
          <div class="left-heading">
            {{ leftSectionTickerData && leftSectionTickerData["watchername"] }}
          </div>
          <div class="right-heading-add" (click)="addAllTickers()">
            <va-icon size="small" name="plus" class="icon va-icon"></va-icon>Add
            All
          </div>
        </div>
        <app-add-modal-section
          [dataToUse]="
            leftSectionTickerData && leftSectionTickerData['company_info']
          "
          field="name"
          company="ticker"
          (addData)="addTicker($event)"
          [maxHeight]="maxHeight"
        ></app-add-modal-section>
      </td>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.color]="modalData.length < 1 ? '#e61F00' : '#363636'"
          >
            Number of selected: {{ modalData && modalData.length }}
          </div>
          <div
            [ngClass]="[
              modalData && modalData.length
                ? 'right-heading-remove'
                : 'greyed-removeall'
            ]"
            (click)="removeAllTickers()"
          >
            <va-icon size="small" name="close" class="icon va-icon"></va-icon
            >Remove All
          </div>
        </div>
        <app-remove-modal-section
          [dataToUse]="modalData"
          field="name"
          company="ticker"
          [maxHeight]="maxHeight"
          (removeData)="removeTicker($event)"
        ></app-remove-modal-section>
      </td>
    </tr>
  </table>
  <div class="save-watchlist" *ngIf="showSaveWatchList">
    <nz-switch
      ngDefaultControl
      [(ngModel)]="saveWatchlist"
      (ngModelChange)="validateWatchlistName()"
      nzSize="small"
    ></nz-switch>
    <label class="highlisht-best-label">Save as watchlist</label>
    <div class="input-and-error" *ngIf="saveWatchlist">
      <input
        type="text"
        ngDefaultControl
        [(ngModel)]="watchlistName"
        (blur)="validateWatchlistName()"
        class="input-watchlist-name"
      />
      <span
        class="error-color watchlist-name-error"
        *ngIf="watchlistError.trim().length > 0"
      >
        <va-icon
          size="small"
          name="exclamation-triangle"
          class="icon va-icon"
        ></va-icon>

        {{ watchlistError }}
      </span>
    </div>
  </div>
  <!-- nzDisabled="isMetaInProgress ||
    isCompsDataInProgress ||
    isUserSettingUpdateInProgress ||
    !lineItem" -->
  <!-- <div *nzModalFooter>
    <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [nzLoading]="isLoading"
      [disabled]="this.modalData.length > 50 ? true : false"
      (click)="updateLineItems()"
    >
      Update
    </button>
  </div> -->
</div>
